import React from 'react';

// Sparkle + bar-chart mark: AI-driven analytics.
export const CodiAnalyticsIcon = ({ fill = 'currentColor', className }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 24 24'
    fill={fill}
    className={className}>
    <path d='M3 20.5h18a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2Z' />
    <path d='M5 11.5h2.5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1Z' />
    <path d='M10.75 8h2.5a1 1 0 0 1 1 1v8.5a1 1 0 0 1-1 1h-2.5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1Z' />
    <path d='M16.5 13.5H19a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2.5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1Z' />
    <path d='M17.4 1.2a.5.5 0 0 1 .95 0l.6 1.75a.5.5 0 0 0 .31.31l1.74.6a.5.5 0 0 1 0 .95l-1.74.6a.5.5 0 0 0-.31.31l-.6 1.75a.5.5 0 0 1-.95 0l-.6-1.75a.5.5 0 0 0-.31-.31l-1.75-.6a.5.5 0 0 1 0-.95l1.75-.6a.5.5 0 0 0 .31-.31l.6-1.75Z' />
  </svg>
);
